import React from 'react';

interface DateTimeInputProps {
  label: string;
  value: string;
  required?: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
}

const DateTimeInput: React.FC<DateTimeInputProps> = ({ label, value, required, disabled, onChange }) => (
  <div className="form-group">
    <label className="form-label">{label}{required && ' *'}</label>
    <input
      type="datetime-local"
      className="form-control"
      value={value || ''}
      required={required}
      title={label}
      placeholder={label}
      disabled={disabled}
      onChange={e => onChange(e.target.value)}
    />
  </div>
);

export default DateTimeInput;
